// extracted by mini-css-extract-plugin
export default {"button":"Button1_button__S9dlB"};